import React, { useState } from "react";
import "./OutsourceDeliver.css";
import img1 from "../outsourceassets/deliver1.png";
import img2 from "../outsourceassets/deliver2.png";
import img3 from "../outsourceassets/deliver3.png";
import img4 from "../outsourceassets/deliver4.png";
import img5 from "../outsourceassets/deliver5.png";
import img6 from "../outsourceassets/deliver6.png";
import img7 from "../outsourceassets/deliver7.png";
import img8 from "../outsourceassets/deliver8.png";

export default function OutsourceDeliver() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      img: img1,
      id: 1,
      title: "Azure DevOps Automated Testing",
      description:
        "Streamline your Azure DevOps infrastructure by automating CI/CD pipelines and running continuous tests right from the start of the software development lifecycle",
    },
    {
      img: img2,
      id: 2,
      title: "AWS Automated Testing Process",
      description:
        "Integrate your AWS DevOps development process with best-in-class automation tools to reduce potential bugs and create robust cloud applications",
    },
    {
      img: img3,
      id: 3,
      title: "Build-Deployment Automation",
      description:
        "Cut down the scope of human intervention so that you can decrease the number of possible errors by thoroughly automating your build and deployment process",
    },
    {
      img: img4,
      id: 4,
      title: "DevOps Workflow Automation",
      description:
        "Embrace DevOps automation best practices and strategies to facilitate an efficient workflow in your business and reduce manual, time-consuming workload",
    },
    {
      img: img5,
      id: 5,
      title: "DevOps Process Automation",
      description:
        "Simplify your development tasks and make the entire ecosystem faster and more productive by enabling comprehensive DevOps process automation",
    },
    {
      img: img6,
      id: 6,
      title: "Continuous Delivery Automation",
      description:
        "Take your deployment and release game to new heights with the required speed, agility, and reliability through a continuous delivery automation plan",
    },
    {
      img: img7,
      id: 7,
      title: "Test Automation and DevOps",
      description:
        "Create a solid automatic testing framework across all the essential stages in your DevOps environment and maintain delivering quality products at a stretch",
    },
    {
      img: img8,
      id: 8,
      title: "DevOps Structure Automation",
      description:
        "Use a rich set of high-performing tools to automate the entire DevOps infrastructure for seamless provision, deployment, and testing of your products",
    },
  ];

  return (
    <div id="outsource-deliver" className="outsourcemainclass">
      <div className="top">
        <h2 className="heading">
          Automating DevOps to Build a Synergistic Business Environment
        </h2>
        <p className="subheading">
          Our DevOps engineers automate deployments using workflow and test
          automation to improve efficiency, reliability, and collaboration
          across the DevOps lifecycle.{" "}
        </p>
      </div>
      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <img src={card.img} alt="error" />
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <img src={card.img} alt="error" />
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
